import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';

function UsaPstn() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'UsaPstn') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate, userEmail]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    //-----------------------------------------------Fields-------------------------------------------------//

    // Donor section
    const [operatorName, setOperatorName] = useState();
    const [accountNumber, setAccountNumber] = useState();
    const [companyName, setCompanyName] = useState();
    const [contactName, setContactName] = useState();
    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [state, setState] = useState();
    const [zip, setZip] = useState();

    // Sign-off
    const [signature, setSignature] = useState();
    const [date, setDate] = useState();
    const [nameAndTitle, setNameAndTitle] = useState();

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#operatorName').value = form?.country?.donor?.operatorName ?? '';
        document.querySelector('#accountNumber').value = form?.country?.donor?.accountNumber ?? '';
        document.querySelector('#companyName').value = form?.country?.donor?.companyName ?? '';
        document.querySelector('#contactName').value = form?.country?.donor?.contactName ?? '';
        document.querySelector('#address').value = form?.country?.donor?.address ?? '';
        document.querySelector('#city').value = form?.country?.donor?.city ?? '';
        document.querySelector('#state').value = form?.country?.donor?.state ?? '';
        document.querySelector('#zip').value = form?.country?.donor?.zip ?? '';
        setOperatorName(form?.country?.donor?.operatorName ?? '');
        setAccountNumber(form?.country?.donor?.accountNumber ?? '');
        setCompanyName(form?.country?.donor?.companyName ?? '');
        setContactName(form?.country?.donor?.contactName ?? '');
        setAddress(form?.country?.donor?.address ?? '');
        setCity(form?.country?.donor?.city ?? '');
        setState(form?.country?.donor?.state ?? '');
        setZip(form?.country?.donor?.zip ?? '');

        setTableData(form?.country?.range ?? []);

        document.querySelector('#signature').value = form?.country?.requestor?.signature ?? '';
        document.querySelector('#date').value = form?.country?.requestor?.date ?? '';
        document.querySelector('#nameAndTitle').value = form?.country?.requestor?.nameAndTitle ?? '';
        setSignature(form?.country?.requestor?.signature ?? '');
        setDate(form?.country?.requestor?.date ?? '');
        setNameAndTitle(form?.country?.requestor?.nameAndTitle ?? '');
    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null);

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Range + BTN)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), rangeStart: '', rangeStop: '', btn: '' }]);

    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), rangeStart: '', rangeStop: '', btn: '' }]);
    };

    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableData(updatedData);
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "UsaPstn",
            "donor": {
                "operatorName": operatorName,
                "accountNumber": accountNumber,
                "companyName": companyName,
                "contactName": contactName,
                "address": address,
                "city": city,
                "state": state,
                "zip": zip
            },
            "range": tableData,
            "requestor": {
                "signature": signature,
                "date": date,
                "nameAndTitle": nameAndTitle
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!operatorName) {
            validationErrors.operatorName = 'please fill in Operator Name';
        }
        if (!accountNumber) {
            validationErrors.accountNumber = 'please fill in Account Number';
        }
        if (!companyName) {
            validationErrors.companyName = 'please fill in Company Name';
        }
        if (!contactName) {
            validationErrors.contactName = 'please fill in Contact Name';
        }
        if (!address) {
            validationErrors.address = 'please fill in Address';
        }
        if (!city) {
            validationErrors.city = 'please fill in City';
        }
        if (!state) {
            validationErrors.state = 'please fill in State';
        }
        if (!zip) {
            validationErrors.zip = 'please fill in Zip';
        }
        tableData.forEach((row, index) => {
            if (!row.rangeStart) {
                validationErrors[`start-${row.id}`] = `please fill in Start Range for row ${index + 1}`;
            }
            if (!row.rangeStop) {
                validationErrors[`end-${row.id}`] = `please fill in End Range for row ${index + 1}`;
            }
            if (!row.btn) {
                validationErrors[`btn-${row.id}`] = `please fill in Billing Telephone Number for row ${index + 1}`;
            }
        });
        if (!signature) {
            validationErrors.signature = 'please fill in Signature';
        }
        if (!date) {
            validationErrors.date = 'please fill in Date';
        }
        if (!nameAndTitle) {
            validationErrors.nameAndTitle = 'please fill in Name and Title';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const el = document.getElementById(firstErrorKey);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }

        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = companyName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home'
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <h2 className='heading'>Number Range</h2> <br></br>

                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Start Range*</th>
                                <th>End Range*</th>
                                <th>Billing Telephone Number (BTN)*</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row) => (
                                <tr key={row.id}>
                                    <td>
                                        <input
                                            type="text"
                                            id={`start-${row.id}`}
                                            value={row.rangeStart}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'rangeStart', value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`start-${row.id}`]: /^\d{10}$/.test(value)
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (!/^\d{10}$/.test(row.rangeStart)) {
                                                    toast.error('Start Range must be exactly 10 digits.');
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            id={`end-${row.id}`}
                                            value={row.rangeStop}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'rangeStop', value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`end-${row.id}`]: /^\d{10}$/.test(value)
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (!/^\d{10}$/.test(row.rangeStop)) {
                                                    toast.error('End Range must be exactly 10 digits.');
                                                } else if (parseInt(row.rangeStop, 10) < parseInt(row.rangeStart, 10)) {
                                                    toast.error('End range must be greater than or equal to start range');
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            id={`btn-${row.id}`}
                                            value={row.btn}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'btn', value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`btn-${row.id}`]: /^\d{10}$/.test(value)
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`btn-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (!/^\d{10}$/.test(row.btn)) {
                                                    toast.error('BTN must be exactly 10 digits.');
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <button onClick={addRow}>Add Row</button>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Identification of Current and Losing Operator / Service Provider (Donor)</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('operatorName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator Name*</label> <br />
                            <input
                                onChange={(e) => setOperatorName(e.target.value)}
                                type="text"
                                id="operatorName"
                                placeholder=""
                                className={`inputbox ${validationStates.operatorName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('operatorName', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'operatorName' && (
                                <div className="hover-description">
                                    Enter current/losing Operator Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('accountNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Account Number*</label> <br />
                            <input
                                onChange={(e) => setAccountNumber(e.target.value)}
                                type="text"
                                id="accountNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.accountNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('accountNumber', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'accountNumber' && (
                                <div className="hover-description">
                                    Enter Account Number
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Enter Company Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Name*</label> <br />
                            <input
                                onChange={(e) => setContactName(e.target.value)}
                                type="text"
                                id="contactName"
                                placeholder=""
                                className={`inputbox ${validationStates.contactName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactName', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'contactName' && (
                                <div className="hover-description">
                                    Enter Contact Name
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter Address
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Enter City
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('state')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>State*</label> <br />
                            <input
                                onChange={(e) => setState(e.target.value)}
                                type="text"
                                id="state"
                                placeholder=""
                                className={`inputbox ${validationStates.state === false ? 'error' : ''}`}
                                onBlur={() => validateInput('state', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'state' && (
                                <div className="hover-description">
                                    Enter State
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip*</label> <br />
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('zip', /^\d{5}(-\d{4})?$/)}
                            />
                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Enter Zip
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Sign Off</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Signature*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Enter Signature
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => { validateInput('date', /^.*$/); }}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('nameAndTitle')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name and Title*</label> <br />
                            <input
                                onChange={(e) => setNameAndTitle(e.target.value)}
                                type="text"
                                id="nameAndTitle"
                                placeholder=""
                                className={`inputbox ${validationStates.nameAndTitle === false ? 'error' : ''}`}
                                onBlur={() => validateInput('nameAndTitle', /^[a-zA-Z0-9\s\W]+$/)}
                            />
                            {hoveredField === 'nameAndTitle' && (
                                <div className="hover-description">
                                    Enter Name and Title
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>

            </div>

        </div>
    );
}

export default UsaPstn;